import { EXPERIENCE } from "../../data/portfolio";
import { Heading, White, Blue, Dim } from "./Primitives";

export default function ExperienceOutput() {
  return (
    <div>
      <Heading>cat experience.log</Heading>
      <div className="space-y-4">
        {EXPERIENCE.map((job, i) => (
          <div key={i}>
            <div>
              <White>{job.role}</White> <Dim>@</Dim> <Blue>{job.company}</Blue>
              <span className="text-neutral-600"> · {job.period}</span>
            </div>
            <ul className="mt-1 space-y-0.5">
              {job.points.map((p, j) => (
                <li key={j} className="text-neutral-400">
                  <span className="text-neutral-600">– </span>{p}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}